import PageHandler from "./PageHandler";
import Pages from "Pages";

class CustomerDetailPageHandler extends PageHandler {
  constructor() {
    super("customer-detail", Pages.CustomerDetailPage);
  }
}

export default CustomerDetailPageHandler;



// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/CustomerDetailPageHandler.js